import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconScratchCard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="scratch-card"><path d="M21.25 4.75H2.75V19.25H21.25V4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M17.5 14L9.55556 15.75L15.6667 12.25L6.5 13.4167L16.4 8.75L6.5 10.5L10.9 8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconScratchCard;
